define([
	'internal_util/Logger',
	'internal_util/Util',
	'model/Error',
	'model/ErrorType',
	'state/UIState',
	'service/UIStateManager',
	'view/SplashScreenView',
	'view/ErrorView',
	'view/ControlBarView',
	'amdi18n-loader?!state/nls/UIState_strings',
	'amdi18n-loader?!state/nls/ErrorState_strings'
], function (
	Logger,
	Util,
	Error,
	ErrorType,
	UIState,
	UIStateManager,
	SplashScreenView,
	ErrorView,
	ControlBarView,
	CommonStrings,
	Strings
) {
	'use strict';

	/**
	 * ErrorState class
	 */
	function ErrorState(uiStateManager) {
		var _uiStateManager,
			_splashScreenView = new SplashScreenView(),
			_errorView = new ErrorView(),
			_controlBarView = new ControlBarView('skIdS_control-bar-error'),
			_nextButton,
			_nextCallback;

		if (uiStateManager instanceof UIStateManager) {
			_uiStateManager = uiStateManager;
		} else {
			throw new Error('no valid uiStateManager found');
		}

		_splashScreenView.disableAnimation();

		_nextButton = _controlBarView.addButton(CommonStrings.next, function () {
			Util.callCallbacks(_nextCallback);
		});

		_controlBarView.addButton(CommonStrings.abort, function () {
			_uiStateManager.abort();
		});


		UIState.call(this, 'error');


		// public methods

		this.title = function () {
			return Strings.error;
		};
		
		this.poweredByImage = function () {
			if (_uiStateManager.core().optionsManager() === null || _uiStateManager.core().optionsManager() === undefined) {
				return null;
			}
			return _uiStateManager.core().optionsManager().providerInfo().poweredByImage();
		};

		this.content = function () {
			return [ _splashScreenView, _errorView ];
		};

		this.controls = function () {
			return _controlBarView;
		};

		this.enter = function (doneCallback, error) {
			_nextCallback = null;
			_nextButton.hide();

			if (typeof error === 'object' && error.hasOwnProperty('error')
					&& error.hasOwnProperty('nextCallback')) {
				_errorView.update(error['error']);

				if (error['error'] instanceof Error && error['error'].type() === ErrorType.RECOVERABLE) {
					_nextCallback = error['nextCallback'];
					_nextButton.show();
				}
			} else {
				_errorView.update(error);
			}

			Util.callCallbacks(doneCallback);
		};

		this.leave = function (doneCallback) {
			_nextCallback = null;

			Util.callCallbacks(doneCallback);
		};
	};

	ErrorState.prototype = Object.create(UIState.prototype);

	return ErrorState;
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/state/ErrorState.js
// module id = 307
// module chunks = 3